import type { SVGProps } from 'react';

export const Play = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.5 16.45v-8.9c0-.267.092-.483.275-.65a.904.904 0 0 1 .625-.25c.083 0 .167.017.25.05a.893.893 0 0 1 .225.075l7 4.45c.133.1.233.217.3.35a.789.789 0 0 1 0 .85.993.993 0 0 1-.3.35l-7 4.45a2.981 2.981 0 0 1-.225.1 1.27 1.27 0 0 1-.25.025.904.904 0 0 1-.625-.25.838.838 0 0 1-.275-.65Zm1.5-1.1L15.275 12 10 8.65v6.7Z" />
    </svg>
  );
};
